import React, { useEffect } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { COLORS, TYPOGRAPHY } from "../constants/color";

const TYPE_CONFIG = {
  success: {
    barColor: "#8CD47E",
    titleColor: COLORS.PRIMARY,
  },
  warning: {
    barColor: "#F8D66D",
    titleColor: COLORS.PRIMARY,
  },
  error: {
    barColor: "#FF6961",
    titleColor: COLORS.ERROR,
  },
  info: {
    barColor: COLORS.SECONDARY,
    titleColor: COLORS.PRIMARY,
  },
};

const AppToast = ({
  open,
  type = "success",
  title,
  message,
  onClose,
  autoHideDuration = 5000,
}) => {
  useEffect(() => {
    if (open && autoHideDuration && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoHideDuration);

      return () => clearTimeout(timer);
    }
  }, [open, autoHideDuration, onClose]);

  if (!open) return null;

  const config = TYPE_CONFIG[type];

  return (
    <Box sx={{ position: "fixed", bottom: 24, right: 24, zIndex: 2000 }}>
      <Box
        sx={{
          position: "relative",
          display: "flex",
          minWidth: 420,
          maxWidth: 500,
          bgcolor: "#fff",
          borderRadius: 2,
          boxShadow: "0px 10px 25px rgba(0,0,0,0.15)",
          overflow: "visible",
          animation: "slideInRight 0.3s ease-out",
          "@keyframes slideInRight": {
            from: { transform: "translateX(100%)", opacity: 0 },
            to: { transform: "translateX(0)", opacity: 1 },
          },
        }}
      >
        {/* Left color bar */}
        <Box sx={{ width: 6, bgcolor: config.barColor }} />

        {/* Content */}
        <Box sx={{ p: 2.5, flex: 1 }}>
          <Typography
            sx={{
              ...TYPOGRAPHY.BODY_LARGE,
              fontWeight: 600,
              color: config.titleColor,
              mb: 0.5,
            }}
          >
            {title}
          </Typography>

          <Typography
  sx={{
    ...TYPOGRAPHY.BODY_SMALL,
    color: COLORS.PRIMARY,
    lineHeight: 1.4,
  }}
  dangerouslySetInnerHTML={{ __html: message }}
/>
        </Box>

      
       {/* Close Button */}
<IconButton
  onClick={onClose}
  size="small"
 sx={{
  position: "absolute",
  top: -12,      // float above card
  right: -10,    // float slightly right
  p: 0.5,
  zIndex: 3,
  bgcolor: "#fff",
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  "&:hover": {
    bgcolor: "#FFECEC",
  },
}}


>
  <CloseIcon fontSize="small" sx={{ color: "#FF6961" }} />
</IconButton>

      </Box>
    </Box>
  );
};

export default AppToast;
